import useCurrentUser from '../../hooks/useCurrentUser';
import AccountAvatar from './AccountAvatar/AccountAvatar';
import config from '../../config';

const { publicAssetUrl } = config;

type NavBarProps = {
  className?: string;
  onToggleMenu: () => void;
};

const NavBar = ({ onToggleMenu }: NavBarProps) => {
  const { data: user } = useCurrentUser();

  return (
    <nav>
      <div className="logo-wrapper">
        <button className="btn min-w-min burger" onClick={onToggleMenu}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </button>
        <div className="hidden md:block w-32">
          <img
            src={`${publicAssetUrl}/brand/logo-primary.svg`}
            alt="Logo"
            className="w-full"
          />
        </div>
        <div className="block md:hidden w-8">
          <img
            src={`${publicAssetUrl}/brand/logo-icon-primary.svg`}
            alt="Logo"
            className="w-full"
          />
        </div>
      </div>
      <div className="flex">
        {!user && <div className="animte-pulse avatar rounded-full"></div>}
        {user && <AccountAvatar />}
      </div>
    </nav>
  );
};

export default NavBar;
